export default __webpack_public_path__ + "static/media/5.773cc902.mp3";